import React, { useState, useEffect } from "react";
import { useParams,useNavigate } from "react-router-dom";



import {
  ChevronDown,
  CalendarDays,
  MapPin,
  Building2,
  Users,
  ArrowRight,
  BookOpen,
  BriefcaseBusiness,
  Monitor,
  BookMarked,
  Newspaper,
  GlassWater,
  Accessibility,
  RefreshCw,
  Library,
  ClipboardList,
  Award,
  GraduationCap,
  ArrowUpRight,
  Download,
  Trophy,
  Briefcase,
  FileText,
  Megaphone,
} from "lucide-react";
import {
  EXAM_NEWS,
  COLLEGE_NOTICES,
  EXAM_PRESS_RELEASES,
  DOWNLOADS,
  ORDINANCE_SYLLABUS,
} from "../../mock";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import API_BASE_URL from "../../api/api";
/* ================= EXAMINATION NOTICE DATA ================= */

/* ================= EXAMINATION NOTICE DATA ================= */

// const EXAM_TABS = [
//   {
//     key: "press-releases",
//     label: "Press Releases",
//     icon: Newspaper,
//   },
//   {
//     key: "announcements",
//     label: "Announcements",
//     icon: Megaphone,
//   },
//   {
//     key: "tenders",
//     label: "Tenders",
//     icon: FileText,
//   },
//   {
//     key: "advertisements",
//     label: "Advertisements",
//     icon: Briefcase,
//   },
//   {
//     key: "awards",
//     label: "Awards",
//     icon: Trophy,
//   },
// ];

console.log('API_BASE_URL', API_BASE_URL)
const ExaminationCellPage = () => {
  return (
    <div className="min-h-screen bg-[var(--paper)]">
      <Header />

      {/* HERO */}
      <section className="relative h-[300px] overflow-hidden">
        <img
          src="/images/campusKumaun.avif"
          alt="Kumaun University"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-4 flex items-center">
          <div className="max-w-3xl text-white">
            {/* Breadcrumb */}
            <div className="flex items-center gap-2 text-sm text-white/70 mb-2">
              <span className="text-[#123B5D] text-lg font-gill">Home</span>
              <span className="text-[#123B5D] text-lg font-gill">/</span>
              <span className="text-[#123B5D] text-lg font-gill">
                Examination Cell
              </span>
            </div>

            <h1 className="text-4xl md:text-6xl font-bold leading-tight text-[#064E3B] font-gill">
              EXAMINATION CELL
            </h1>
          </div>
        </div>
      </section>

      {/* STATS */}
{/* button start links */}
{/* ================= EXAMINATION QUICK LINKS ================= */}
<section className="bg-white py-4 px-6">
  <div className="max-w-7xl mx-auto">

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">

      {/* Button 1 */}
      <a
        href="https://kuntl.net/students/login"
         target="_blank"
         rel="noopener noreferrer"
        className="group flex items-center justify-start gap-3  p-3 w-[70%] rounded-xl
        bg-[#08245c] text-white shadow-md
        hover:bg-[#B5121B] transition-all duration-300 font-gill"
      >
        <span className="font-gill font-semibold text-base">
        KU ERP Login-Student
        </span>
        <span className="text-xl group-hover:translate-x-1 transition-transform">
          →
        </span>
      </a>

      {/* Button 2 */}
      <a
        href="https://kuntl.net/college/College"
         target="_blank"
         rel="noopener noreferrer"
        className="group flex items-center justify-start gap-3  p-3 w-[70%] rounded-xl
        bg-[#08245c] text-white shadow-md
        hover:bg-[#B5121B] transition-all duration-300 font-gill"
      >
        <span className="font-gill font-semibold text-base">
          KU ERP Login-College
        </span>
        <span className="text-xl group-hover:translate-x-1 transition-transform">
          →
        </span>
      </a>

      {/* Button 3 */}
      <a
        href="https://kunainital.samarth.edu.in/index.php/site/login"
         target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center justify-start gap-3  p-3 w-[80%] rounded-xl
        bg-[#08245c] text-white shadow-md
        hover:bg-[#B5121B] transition-all duration-300 font-gill"
      >
        <span className="font-gill font-semibold text-base">
          KU Samarth Login-Student
        </span>
        <span className="text-xl group-hover:translate-x-1 transition-transform">
          →
        </span>
      </a>

      {/* Button 4 */}
      <a
        href="https://kunainital.samarth.ac.in/index.php/site/login"
         target="_blank"
         rel="noopener noreferrer"
        className="group flex items-center justify-start gap-3  p-3 w-[80%] rounded-xl
        bg-[#08245c] text-white shadow-md
        hover:bg-[#B5121B] transition-all duration-300 font-gill"
      >
        <span className="font-gill font-semibold text-base">
           KU Samarth Login-College
        </span>
        <span className="text-xl group-hover:translate-x-1 transition-transform">
          →
        </span>
      </a>

    </div>
  </div>
</section>
{/* button end links */}
      {/* ================= EXAMINATION CELL INTRO ================= */}
   <section className="relative overflow-hidden bg-[#f8fafc] pt-0 pb-2 md:pt-0 md:pb-4">
        {/* Background Decoration */}
        <div className="absolute -top-20 -left-20 w-64 h-64 rounded-full bg-[#B5121B]/5" />
        <div className="absolute -bottom-32 -right-20 w-80 h-80 rounded-full bg-[#08245c]/5" />

        <div className="relative max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-[1fr_350px] gap-10 lg:gap-14 items-center">
            {/* ================= LEFT ================= */}
            <div>
              {/* Label */}
              <div className="flex items-center gap-3 mb-4">
                {/* <span className="w-10 h-[3px] bg-[#B5121B] rounded-full"></span>

                    <span className="text-xs md:text-sm font-bold tracking-[0.18em] uppercase text-[#B5121B]">
                        University Administration
                    </span> */}
              </div>

              {/* Heading */}
              <h6 className="md:text-1xl font-bold text-[#e1480b] leading-tight text-lg font-gill">
               Academic services
              </h6>
              <h1 className="md:text-5xl font-bold text-[#08245c] leading-tight text-lg font-gill">
                Examination Cell
              </h1>
              <p className="text-[18px] md:text-[16px] leading-7 text-[#40536b] text-justify text-lg font-gill">
                Your central destination for examination notices, datesheets, results, ordinances, syllabi, examination forms, admit cards and certificate services.
              </p>

              {/* Small Divider */}
              <div className="mt-4 flex items-center gap-2">
                <span className="w-14 h-[3px] bg-[#B5121B] rounded-full"></span>
                <span className="w-3 h-[3px] bg-[#08245c] rounded-full"></span>
              </div>
            <h6 className="md:text-3xl font-bold text-[#08245c] leading-tight text-lg font-gill">
              About the Examination Cell
              </h6>
              {/* Content */}
              <div className="mt-7 max-w-4xl space-y-5">
                <p className="text-[18px] md:text-[16px] leading-7 text-[#40536b] text-justify text-lg font-gill">
                  The Examination Cell at Kumaun University serves as a crucial
                  administrative unit responsible for overseeing all aspects
                  related to assessments, examinations, and academic
                  evaluations. With a commitment to maintaining the integrity of
                  the university's evaluation processes, the Examination Cell
                  plays a pivotal role in ensuring fair and accurate assessment
                  of student's academic performance.
                </p>

                <p className="text-[18px] md:text-[16px] leading-7 text-[#40536b] text-justify text-lg font-gill">
                  Comprising a team of experienced professionals, the
                  Examination Cell meticulously plans, coordinates, and executes
                  various examination-related activities. From scheduling and
                  conducting regular semester examinations to organizing
                  supplementary exams and re-evaluation processes, the cell
                  maintains a well-structured framework to manage the entire
                  examination cycle efficiently.
                </p>
              </div>
            </div>

            {/* ================= RIGHT CONTACT CARD ================= */}
           <div className="relative lg:mt-8">
  {/* Back Layer */}
  <div
    className="
      absolute top-3 right-3
      w-full h-full
      rounded-3xl
      bg-[#B5121B]/10
    "
  ></div>

  {/* Card */}
  <div
    className="
      relative bg-white
      rounded-3xl
      border border-gray-100
      shadow-[0_15px_35px_rgba(8,36,92,0.12)]
      overflow-hidden
    "
  >
    {/* Top Border */}
    <div className="h-2 bg-gradient-to-r from-[#B5121B] via-[#B5121B] to-[#08245c]"></div>

    <div className="p-7 md:p-8">
      {/* Card Heading */}
      <div className="flex items-center gap-4 mb-6">
        {/* <div
          className="
            w-12 h-12 rounded-2xl
            bg-[#fff1f1]
            flex items-center justify-center
            shrink-0
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#B5121B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 10c0 6-8 11-8 11S4 16 4 10a8 8 0 1 1 16 0Z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
        </div> */}

        <div>
          <h2 className="text-xl md:text-2xl font-bold text-[#08245c] font-gill">
            Examination Cell Officials
          </h2>
        </div>
      </div>

      {/* Contact Box */}
      <div className="rounded-2xl bg-[#f8fafc] border border-gray-100 p-6">
     

        

        {/* Divider */}
        {/* <div className="border-t border-gray-200 my-0"></div> */}

        {/* Examination Cell Officials */}
      

        <div className="space-y-4">
          {/* Controller of Examination */}
          <div>
            <p className="font-gill text-sm text-[hsl(347,94%,43%)] mb-0">
              Controller of Examination
            </p>
            <p className="font-gill text-base font-semibold text-[#08245c]">
              Prof. Reetesh Sah
            </p>
          </div>
          <div className="border-t border-gray-200 my-0"></div>

          {/* Deputy Controller of Examination */}
          <div>
            <p className="font-gill text-sm text-[hsl(347,94%,43%)] mb-1">
              Deputy Controller of Examination
            </p>
            <p className="font-gill text-base font-semibold text-[#08245c]">
              Dr. Nandan Singh Bisht
            </p>
          </div>
            <div className="border-t border-gray-200 my-0"></div>
          {/* Official Queries */}
          <div>
            <p className="font-gill text-sm text-[hsl(347,94%,43%)] mb-1">
              Official Queries
            </p>
            <a
              href="mailto:coe@kunainital.ac.in"
              className="font-gill text-base font-semibold text-[#08245c] hover:text-[#ee590f] transition-colors break-all"
            >
              coe@kunainital.ac.in
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
          </div>
        </div>
      </section>
      <ExaminationNoticeBoard />
      {/* Examination Cell Start */}
      
      {/* Examination Cell End */}
      <Footer />
    </div>
  );
};
/* =========================================================
   EXAMINATION NOTICE BOARD
========================================================= */

const ExaminationNoticeBoard = () => {
   const navigate = useNavigate();
  const [active, setActive] = useState("");
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  

const [faculties, setFaculties] = useState([]);
const [departments, setDepartments] = useState([]);

const [selectedFaculty, setSelectedFaculty] = useState("");
const [selectedDepartment, setSelectedDepartment] = useState("");

const [facultyLoading, setFacultyLoading] = useState(false);
const [departmentLoading, setDepartmentLoading] = useState(false);
const [modalError, setModalError] = useState("");

  // const API_URL =
  //   window.location.hostname === "localhost" ||
  //   window.location.hostname === "127.0.0.1"
  //     ? "http://127.0.0.1:8000/api/examination-cell-documents"
  //     : "https://api.kunainital.ac.in/api/examination-cell-documents";
const API_URL = `${API_BASE_URL}/examination-cell-documents`;
  // ============================
  // FORMAT EVENT TYPE
  // ============================
  const formatEventType = (value) => {
    if (!value) return "";

    return value
      .replace(/[-_]/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };


  // ============================
  // FETCH API DATA
  // ============================
  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        setLoading(true);
        setError("");

        const response = await fetch(API_URL);

        if (!response.ok) {
          throw new Error(
            `HTTP Error: ${response.status}`
          );
        }

        const result = await response.json();
//         console.log(
//   "API FIELD CHECK:",
//   result.data.map((item) => ({
//     id: item.id,
//     heading: item.heading,
//     event_type: item.event_type,
//     sequence_id: item.sequence_id,
//     status: item.status,
//   }))
// );
// console.log("API DATA:", result.data);
//         console.log(
//           "Examination API Response:",
//           result
//         );

        if (
          result.status === true &&
          Array.isArray(result.data)
        ) {
          const activeDocuments = result.data.filter(
            (item) => Number(item.status) === 1
          );

          setDocuments(activeDocuments);

          // ============================
          // FIRST TAB AUTOMATICALLY ACTIVE
          // ============================
          if (activeDocuments.length > 0) {
            setActive(activeDocuments[0].event_type);
          }
        } else {
          setDocuments([]);
          setError(
            "No examination documents found."
          );
        }
      } catch (err) {
        console.error(
          "Examination API Error:",
          err
        );

        setDocuments([]);
        setError(
          "Unable to load examination documents."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, []);

  // ============================
  // DYNAMIC TABS FROM API
  // ============================
  const dynamicTabs = [
  ...new Map(
    documents
      .filter((item) => item.event_type?.trim())
      .map((item) => [
        item.event_type.trim(),
        item,
      ])
  ).values(),
];

// console.log("Documents state:", documents);
// console.log("Dynamic tabs:", dynamicTabs);
  // ============================
  // ACTIVE TAB DATA
  // ============================
  const currentData = documents.filter(
    (item) => item.event_type === active
  );

  // ============================
  // CURRENT EVENT TYPE
  // ============================
  const currentEventType = active
    ? formatEventType(active)
    : "Documents";

    // syllabus api start
    
const FACULTIES_API = `${API_BASE_URL}/faculties`;
const DEPARTMENTS_API = `${API_BASE_URL}/departments`;

const slugify = (value = "") =>
  value
    .toLowerCase()
    .trim()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

// Fetch active faculties when modal opens
useEffect(() => {
  if (!showModal) return;

  const fetchFaculties = async () => {
    try {
      setFacultyLoading(true);
      setModalError("");

      const response = await fetch(FACULTIES_API);

      if (!response.ok) {
        throw new Error("Unable to load faculties.");
      }

      const result = await response.json();

      if (result.status && Array.isArray(result.data)) {
        setFaculties(
          result.data.filter(
            (item) => Number(item.status) === 1
          )
        );
      } else {
        setFaculties([]);
        setModalError("No faculties found.");
      }
    } catch (error) {
      console.error("Faculty API error:", error);
      setFaculties([]);
      setModalError("Unable to load faculties.");
    } finally {
      setFacultyLoading(false);
    }
  };

  fetchFaculties();
}, [showModal]);

// Fetch departments when faculty changes
useEffect(() => {
  if (!selectedFaculty) {
    setDepartments([]);
    setSelectedDepartment("");
    return;
  }

  const fetchDepartments = async () => {
    try {
      setDepartmentLoading(true);
      setModalError("");
      setDepartments([]);
      setSelectedDepartment("");

      const response = await fetch(DEPARTMENTS_API);

      if (!response.ok) {
        throw new Error("Unable to load departments.");
      }

      const result = await response.json();

      if (result.status && Array.isArray(result.data)) {
        const facultyDepartments = result.data.filter(
          (item) =>
            Number(item.status) === 1 &&
            Number(item.faculty_id) === Number(selectedFaculty)
        );

        setDepartments(facultyDepartments);

        if (facultyDepartments.length === 0) {
          setModalError(
            "No departments found for this faculty."
          );
        }
      } else {
        setDepartments([]);
        setModalError("Unable to load departments.");
      }
    } catch (error) {
      console.error("Department API error:", error);
      setDepartments([]);
      setModalError("Unable to load departments.");
    } finally {
      setDepartmentLoading(false);
    }
  };

  fetchDepartments();
}, [selectedFaculty]);

    // syllabus api end

  return (
  <section className="relative overflow-hidden bg-[#f8fafc] pt-1 pb-1 md:pt-1 md:pb-2">

      {/* ================= BACKGROUND SHAPES ================= */}
      <div
        className="
          absolute
          -top-32
          -left-32
          w-80
          h-80
          rounded-full
          bg-[#B5121B]/5
        "
      />

      <div
        className="
          absolute
          -bottom-40
          -right-32
          w-96
          h-96
          rounded-full
          bg-[#08245c]/5
        "
      />

      <div className="relative max-w-7xl mx-auto px-2">

        {/* ================= HEADER ================= */}

        <div className="text-center">

          <div
            className="
              inline-flex
              items-center
              gap-2
              px-4
              py-2
              rounded-full
              bg-[#fff1f1]
              border
              border-[#B5121B]/10
            "
          >
            <span
              className="
                w-2
                h-2
                rounded-full
                bg-[#B5121B]
                animate-pulse
              "
            />

            <span
              className="
                text-[11px]
                md:text-xs
                font-bold
                uppercase
                tracking-[0.18em]
                text-[#B5121B]
                text-lg font-gill
              "
            >
             Student Services
            </span>
          </div>

          {/* <h2
            className="
              mt-5
              text-3xl
              md:text-5xl
              font-bold
              text-[#08245c]
              text-lg font-gill
            "
          >
           Student Services
            </h2> */}

          {/* <p
            className="
              mt-4
              max-w-2xl
              mx-auto
              
              md:text-base
              leading-7
              text-[#64748b]
              text-lg font-gill
            "
          >
          Quick access to commonly used examination resources.
          </p> */}

          {/* Decorative Divider */}

          <div
            className="
              mt-6
              flex
              items-center
              justify-center
              gap-2
            "
          >
            <span
              className="
                w-16
                h-[3px]
                rounded-full
                bg-[#B5121B]
              "
            />

            <span
              className="
                w-3
                h-3
                rotate-45
                border-2
                border-[#08245c]
              "
            />

            <span
              className="
                w-16
                h-[3px]
                rounded-full
                bg-[#08245c]
              "
            />
          </div>
        </div>
        {/* modal start */}
        
{/* FACULTY & DEPARTMENT MODAL */}
{showModal && (
  <div
    className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 p-4"
    onClick={() => setShowModal(false)}
  >
    <div
      className="w-full max-w-xl rounded-2xl bg-white shadow-2xl overflow-hidden"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Modal Header */}
      <div className="flex items-center justify-between bg-[#08245c] px-6 py-5">
        <div>
          <h2 className="text-xl font-bold text-white font-gill">
            Faculty & Department
          </h2>
          <p className="mt-1 text-sm text-white/80 font-gill">
            Select a faculty and its department
          </p>
        </div>

        <button
          type="button"
          onClick={() => setShowModal(false)}
          className="text-3xl leading-none text-white hover:text-red-200"
          aria-label="Close modal"
        >
          &times;
        </button>
      </div>

      {/* Modal Body */}
      <div className="space-y-6 p-6">

        {/* Faculty Dropdown */}
        <div>
          <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-[#24364b]">
            <GraduationCap size={19} className="text-[#B5121B]" />
            Select Faculty
          </label>

          <div className="relative">
            <select
              value={selectedFaculty}
              onChange={(e) => {
                setSelectedFaculty(e.target.value);
                setModalError("");
              }}
              disabled={facultyLoading}
              className="w-full appearance-none rounded-xl border border-gray-300 bg-white px-4 py-3 pr-10 text-sm text-gray-700 outline-none focus:border-[#B5121B] focus:ring-2 focus:ring-red-100 disabled:bg-gray-100"
            >
              <option value="">
                {facultyLoading
                  ? "Loading faculties..."
                  : "Choose Faculty"}
              </option>

              {faculties.map((faculty) => (
                <option key={faculty.id} value={faculty.id}>
                  {faculty.name}
                </option>
              ))}
            </select>

            <ChevronDown
              size={18}
              className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
            />
          </div>
        </div>

        {/* Department Dropdown */}
        <div>
          <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-[#24364b]">
            <Building2 size={18} className="text-[#B5121B]" />
            Select Department
          </label>

          <div className="relative">
           {/* <select
  value={selectedDepartment}
 onChange={(e) => {
  const departmentId = e.target.value;

  setSelectedDepartment(departmentId);
  setModalError("");

  if (!departmentId || !selectedFaculty) return;

  const faculty = faculties.find(
    (item) => Number(item.id) === Number(selectedFaculty)
  );

  const department = departments.find(
    (item) => Number(item.id) === Number(departmentId)
  );

  if (!faculty || !department) {
    setModalError("Please select a valid department.");
    return;
  }

  setShowModal(false);

  navigate(
    `/faculty/${slugify(faculty.name)}/${slugify(department.name)}`
  );
}}
              disabled={!selectedFaculty || departmentLoading}
              className="w-full appearance-none rounded-xl border border-gray-300 bg-white px-4 py-3 pr-10 text-sm text-gray-700 outline-none focus:border-[#B5121B] focus:ring-2 focus:ring-red-100 disabled:cursor-not-allowed disabled:bg-gray-100"
            >
              <option value="">
                {!selectedFaculty
                  ? "Select faculty first"
                  : departmentLoading
                  ? "Loading departments..."
                  : "Choose Department"}
              </option>

              {departments.map((department) => (
                <option key={department.id} value={department.id}>
                  {department.name}
                </option>
              ))}
            </select> */}
<select
  value={selectedDepartment}
  onChange={(e) => {
    setSelectedDepartment(e.target.value);
    setModalError("");
  }}
  disabled={!selectedFaculty || departmentLoading}
  className="w-full appearance-none rounded-xl border border-gray-300 bg-white px-4 py-3 pr-10 text-sm text-gray-700 outline-none focus:border-[#B5121B] focus:ring-2 focus:ring-red-100 disabled:cursor-not-allowed disabled:bg-gray-100"
>
  <option value="">
    {!selectedFaculty
      ? "Select faculty first"
      : departmentLoading
      ? "Loading departments..."
      : "Choose Department"}
  </option>

  {departments.map((department) => (
    <option key={department.id} value={department.id}>
      {department.name}
    </option>
  ))}
</select>
            <ChevronDown
              size={18}
              className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
            />
          </div>
        </div>

        {/* Error Message */}
        {modalError && (
          <p className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-600">
            {modalError}
          </p>
        )}

        {/* Buttons */}
        <div className="flex flex-col-reverse gap-3 border-t border-gray-100 pt-5 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={() => setShowModal(false)}
            className="rounded-xl border border-gray-300 px-5 py-3 text-sm font-semibold text-gray-600 transition hover:bg-gray-50"
          >
            Cancel
          </button>

          <button
            type="button"
            disabled={!selectedFaculty || !selectedDepartment}
            onClick={() => {
              const faculty = faculties.find(
                (item) =>
                  Number(item.id) === Number(selectedFaculty)
              );

              const department = departments.find(
                (item) =>
                  Number(item.id) === Number(selectedDepartment)
              );

              if (!faculty || !department) {
                setModalError(
                  "Please select a valid faculty and department."
                );
                return;
              }

              setShowModal(false);

              navigate(
              `/faculty/${slugify(faculty.name)}/${slugify(department.name)}`
            );
            }}
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#B5121B] px-6 py-3 text-sm font-semibold text-white transition hover:bg-[#08245c] disabled:cursor-not-allowed disabled:opacity-40"
          >
            Open Ordinance & Syllabus
            <ArrowRight size={17} />
          </button>
        </div>
      </div>
    </div>
  </div>
)}

        {/* modal end */}

        {/* ================= DYNAMIC TABS ================= */}

  {/* ================= DYNAMIC TABS ================= */}

{!loading && (
<div className="mt-2 flex flex-wrap justify-center gap-3">
    {dynamicTabs.map((tab) => {
      const eventType = tab.event_type;
      const isActive = eventType === active;
      const sequenceId = Number(tab.sequence_id);

      return (
        <button
          key={eventType}
          type="button"
          onClick={() => {
            if (sequenceId === 4) {
              setShowModal(true);
            } else {
              setActive(eventType);
            }
          }}
          className={`
            inline-flex items-center gap-2
            px-5 py-3 rounded-xl border
            text-sm font-gill
            transition-all duration-300
            ${
              isActive
                ? "bg-[#B5121B] text-white border-[#B5121B] shadow-lg"
                : "bg-white text-[#24364b] border-gray-200 hover:border-[#B5121B]/40 hover:text-[#B5121B]"
            }
          `}
        >
          <FileText size={17} />
          {formatEventType(eventType)}
        </button>
      );
    })}
  </div>
)}
        {/* ================= NOTICE LIST ================= */}

        <div
          className="
            mt-4
            grid
            md:grid-cols-2
            gap-5
          "
        >

          {/* ================= LOADING ================= */}

          {loading && (
            <div
              className="
                md:col-span-2
                flex
                justify-center
                items-center
                py-12
                text-[#64748b]
                text-sm
              "
            >
              Loading examination documents...
            </div>
          )}

          {/* ================= ERROR ================= */}

          {!loading && error && (
            <div
              className="
                md:col-span-2
                text-center
                py-12
                text-red-500
                text-sm
              "
            >
              {error}
            </div>
          )}

          {/* ================= NO DATA ================= */}

          {!loading &&
            !error &&
            currentData.length === 0 && (
              <div
                className="
                  md:col-span-2
                  text-center
                  py-12
                  text-[#64748b]
                  text-sm
                "
              >
                No {currentEventType.toLowerCase()}{" "}
                available.
              </div>
            )}

          {/* ================= API DATA ================= */}

          {!loading &&
            !error &&
            currentData.map((item) => (
              <a
                key={item.id}
                href={item.pdf_path || item.external_link}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  group
                  relative
                  flex
                  items-center
                  gap-5
                  bg-white
                  rounded-2xl
                  border border-[var(--cream-deep)]
                  border-gray-100
                  p-5
                  md:p-6
                  overflow-hidden
                  shadow-sm
                  
                  hover:shadow-[0_15px_35px_rgba(8,36,92,0.10)]
                  hover:-translate-y-1
                  transition-all
                  duration-300
                "
              >
                
               <div className="shrink-0 w-14 h-14 rounded-xl text-lg font-gill bg-[var(--terracotta)]/10 flex flex-col items-center justify-center">
                <FileText
                  size={25}
                  className="text-[var(--terracotta)]"
                />

              {item.publish_date && (
                <span className="text-[12px] text-blue-500 font-bold mt-3 whitespace-nowrap">
                  {item.publish_date}
                </span>
              )}
              </div>
               <div className="h-14 w-px bg-[var(--cream-deep)]" />
                {/* Hover Red Line */}

                <div
                  className="
                    absolute
                    left-0
                    top-0
                    bottom-0
                    w-1
                    bg-[#B5121B]
                    scale-y-0
                    group-hover:scale-y-100
                    transition-transform
                    duration-300
                    text-lg font-gill
                  "
                />

                {/* ================= CONTENT ================= */}

                <div className="flex-1 min-w-0">

                  {/* CATEGORY */}

                  <div
                    className="
                      flex
                      items-center
                      gap-2
                      mb-2
                    "
                  >
                    <span
                      className="
                        text-[10px]
                        font-bold
                        uppercase
                        tracking-[0.15em]
                        text-[#B5121B]
                      "
                    >
                      {formatEventType(
                        item.event_type
                      )}
                    </span>
                  </div>

                  {/* TITLE */}

                  <h3
                    className="
                      text-[15px]
                      md:text-[16px]
                      font-gill
                      leading-6
                      text-[#24364b]
                      group-hover:text-[#B5121B]
                      transition-colors
                    "
                  >
                    {item.heading}
                  </h3>

                  {/* VIEW DETAILS */}

                  <div
                    className="
                      mt-3
                      inline-flex
                      items-center
                      gap-1.5
                      text-xs
                      font-bold
                      text-[#08245c]
                      group-hover:text-[#B5121B]
                    "
                  >
                    View Details

                    <ArrowUpRight size={14} />
                  </div>
                </div>

                {/* ================= RIGHT ARROW ================= */}

                <div
                  className="
                    hidden
                    sm:flex
                    shrink-0
                    w-10
                    h-10
                    rounded-full
                    bg-[#f8fafc]
                    items-center
                    justify-center
                    text-[#08245c]
                    group-hover:bg-[#fff1f1]
                    group-hover:text-[#B5121B]
                    transition-all
                  "
                >
                  <ArrowRight size={17} />
                </div>

              </a>
            ))}

            {/* view button add start */}
            
            {/* view button add end */}
        </div>

        {/* ================= VIEW ALL ================= */}

        {/* {!loading &&
          !error &&
          currentData.length > 0 && (
            <div
              className="
                mt-10
                flex
                justify-center
              "
            >
              <a
                href="#"
                className="
                  group
                  inline-flex
                  items-center
                  gap-3
                  px-7
                  py-3.5
                  rounded-xl
                  bg-[#08245c]
                  text-white
                  text-sm
                  font-gill
                  shadow-lg
                  hover:bg-[#B5121B]
                  transition-all
                  duration-300
                "
              >
                View All{" "}
                {currentEventType}

                <span
                  className="
                    w-7
                    h-7
                    rounded-full
                    bg-white/10
                    flex
                    items-center
                    justify-center
                    group-hover:translate-x-1
                    transition-transform
                  "
                >
                  <ArrowUpRight size={14} />
                </span>
              </a>
            </div>
          )} */}

{!loading && !error && currentData.length > 0 && (
  <div className="mt-10 flex justify-center">
    <button
      type="button"
      onClick={() =>
        navigate(
          `/examination-cell/notices?tab=${encodeURIComponent(active)}`
        )
      }
      className="inline-flex items-center gap-3 px-7 py-3.5 rounded-xl bg-[#08245c] text-white font-semibold hover:bg-[#B5121B] transition-all"
    >
      View All {currentEventType}
      <ArrowUpRight size={17} />
    </button>
  </div>
)}

      </div>
    </section>
  );
};

// const ExaminationNoticeBoard = () => {
//   const [active, setActive] = useState("press-releases");
//   const [documents, setDocuments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const API_URL =
//     window.location.hostname === "localhost" ||
//     window.location.hostname === "127.0.0.1"
//       ? "http://127.0.0.1:8000/api/examination-cell-documents"
//       : "https://api.kunainital.ac.in/api/examination-cell-documents";

//   useEffect(() => {
//     const fetchDocuments = async () => {
//       try {
//         setLoading(true);
//         setError("");

//         const response = await fetch(API_URL);

//         if (!response.ok) {
//           throw new Error("Failed to fetch examination documents");
//         }

//         const result = await response.json();

//         console.log("Examination API Response:", result);

//         if (result.status === true && Array.isArray(result.data)) {
//           setDocuments(result.data);
//         } else {
//           setDocuments([]);
//           setError("No examination documents found.");
//         }
//       } catch (err) {
//         console.error("Examination API Error:", err);
//         setError("Unable to load examination documents.");
//         setDocuments([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDocuments();
//   }, []);

//   // ============================
//   // FILTER ACTIVE TAB DATA
//   // ============================
//   const currentData = documents.filter(
//     (item) => item.event_type === active && Number(item.status) === 1,
//   );

//   const currentTab =
//     EXAM_TABS.find((tab) => tab.key === active) || EXAM_TABS[0];

//   return (
//     <section className="relative overflow-hidden bg-[#f8fafc] py-16 md:py-20">
//       {/* Background Shapes */}
//       <div
//         className="
//                 absolute
//                 -top-32
//                 -left-32
//                 w-80
//                 h-80
//                 rounded-full
//                 bg-[#B5121B]/5
//             "
//       />

//       <div
//         className="
//                 absolute
//                 -bottom-40
//                 -right-32
//                 w-96
//                 h-96
//                 rounded-full
//                 bg-[#08245c]/5
//             "
//       />

//       <div className="relative max-w-7xl mx-auto px-6">
//         {/* ================= HEADER ================= */}

//         <div className="text-center">
//           <div
//             className="
//                         inline-flex
//                         items-center
//                         gap-2
//                         px-4
//                         py-2
//                         rounded-full
//                         bg-[#fff1f1]
//                         border
//                         border-[#B5121B]/10
//                     "
//           >
//             <span
//               className="
//                             w-2
//                             h-2
//                             rounded-full
//                             bg-[#B5121B]
//                             animate-pulse
//                         "
//             />

//             <span
//               className="
//                             text-[11px]
//                             md:text-xs
//                             font-bold
//                             uppercase
//                             tracking-[0.18em]
//                             text-[#B5121B]
//                         "
//             >
//               Examination Notice Board
//             </span>
//           </div>

//           <h2
//             className="
//                         mt-5
//                         text-3xl
//                         md:text-5xl
//                         font-bold
//                         text-[#08245c]
//                     "
//           >
//             Latest Examination
//             <span className="text-[#B5121B] ml-2">Updates</span>
//           </h2>

//           <p
//             className="
//                         mt-4
//                         max-w-2xl
//                         mx-auto
//                         text-sm
//                         md:text-base
//                         leading-7
//                         text-[#64748b]
//                     "
//           >
//             Access the latest examination notices, date sheets, results and
//             admit card information.
//           </p>

//           {/* Decorative Divider */}
//           <div
//             className="
//                         mt-6
//                         flex
//                         items-center
//                         justify-center
//                         gap-2
//                     "
//           >
//             <span
//               className="
//                             w-16
//                             h-[3px]
//                             rounded-full
//                             bg-[#B5121B]
//                         "
//             />

//             <span
//               className="
//                             w-3
//                             h-3
//                             rotate-45
//                             border-2
//                             border-[#08245c]
//                         "
//             />

//             <span
//               className="
//                             w-16
//                             h-[3px]
//                             rounded-full
//                             bg-[#08245c]
//                         "
//             />
//           </div>
//         </div>

//         {/* ================= TABS ================= */}

//         <div
//           className="
//                     mt-10
//                     flex
//                     flex-wrap
//                     justify-center
//                     gap-3
//                 "
//         >
//           {EXAM_TABS.map((tab) => {
//             const Icon = tab.icon;
//             const isActive = tab.key === active;

//             return (
//               <button
//                 key={tab.key}
//                 onClick={() => setActive(tab.key)}
//                 className={`
//                                     inline-flex
//                                     items-center
//                                     gap-2
//                                     px-5
//                                     py-3
//                                     rounded-xl
//                                     border
//                                     text-sm
//                                     font-semibold
//                                     transition-all
//                                     duration-300
//                                     ${
//                                       isActive
//                                         ? "bg-[#B5121B] text-white border-[#B5121B] shadow-lg -translate-y-0.5"
//                                         : "bg-white text-[#24364b] border-gray-200 hover:border-[#B5121B]/40 hover:text-[#B5121B] hover:-translate-y-0.5"
//                                     }
//                                 `}
//               >
//                 <Icon size={17} />

//                 {tab.label}
//               </button>
//             );
//           })}
//         </div>

//         {/* ================= NOTICE LIST ================= */}

//         <div
//           className="
//                     mt-10
//                     grid
//                     md:grid-cols-2
//                     gap-5
//                 "
//         >
//           {/* LOADING */}
//           {loading && (
//             <div
//               className="
//                             md:col-span-2
//                             flex
//                             justify-center
//                             items-center
//                             py-12
//                             text-[#64748b]
//                             text-sm
//                         "
//             >
//               Loading examination documents...
//             </div>
//           )}

//           {/* ERROR */}
//           {!loading && error && (
//             <div
//               className="
//                             md:col-span-2
//                             text-center
//                             py-12
//                             text-red-500
//                             text-sm
//                         "
//             >
//               {error}
//             </div>
//           )}

//           {/* NO DATA */}
//           {!loading && !error && currentData.length === 0 && (
//             <div
//               className="
//                                 md:col-span-2
//                                 text-center
//                                 py-12
//                                 text-[#64748b]
//                                 text-sm
//                             "
//             >
//               No {currentTab.label.toLowerCase()} available.
//             </div>
//           )}

//           {/* ================= API DATA ================= */}

//           {!loading &&
//             !error &&
//             currentData.map((item) => (
//               <a
//                 key={item.id}
//                 href={item.pdf_path}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="
//                                     group
//                                     relative
//                                     flex
//                                     items-center
//                                     gap-5
//                                     bg-white
//                                     rounded-2xl
//                                     border
//                                     border-gray-100
//                                     p-5
//                                     md:p-6
//                                     overflow-hidden
//                                     shadow-sm
//                                     hover:shadow-[0_15px_35px_rgba(8,36,92,0.10)]
//                                     hover:-translate-y-1
//                                     transition-all
//                                     duration-300
//                                 "
//               >
//                 {/* Hover Red Line */}
//                 <div
//                   className="
//                                     absolute
//                                     left-0
//                                     top-0
//                                     bottom-0
//                                     w-1
//                                     bg-[#B5121B]
//                                     scale-y-0
//                                     group-hover:scale-y-100
//                                     transition-transform
//                                     duration-300
//                                 "
//                 />

//                 {/* ================= CONTENT ================= */}

//                 <div className="flex-1 min-w-0">
//                   {/* CATEGORY */}

//                   <div
//                     className="
//                                         flex
//                                         items-center
//                                         gap-2
//                                         mb-2
//                                     "
//                   >
//                     <span
//                       className="
//                                             text-[10px]
//                                             font-bold
//                                             uppercase
//                                             tracking-[0.15em]
//                                             text-[#B5121B]
//                                         "
//                     >
//                       {currentTab.label}
//                     </span>
//                   </div>

//                   {/* TITLE */}

//                   <h3
//                     className="
//                                         text-[15px]
//                                         md:text-[16px]
//                                         font-semibold
//                                         leading-6
//                                         text-[#24364b]
//                                         group-hover:text-[#B5121B]
//                                         transition-colors
//                                     "
//                   >
//                     {item.heading}
//                   </h3>

//                   {/* VIEW DETAILS */}

//                   <div
//                     className="
//                                         mt-3
//                                         inline-flex
//                                         items-center
//                                         gap-1.5
//                                         text-xs
//                                         font-bold
//                                         text-[#08245c]
//                                         group-hover:text-[#B5121B]
//                                     "
//                   >
//                     View Details
//                     <ArrowUpRight size={14} />
//                   </div>
//                 </div>

//                 {/* ================= RIGHT ARROW ================= */}

//                 <div
//                   className="
//                                     hidden
//                                     sm:flex
//                                     shrink-0
//                                     w-10
//                                     h-10
//                                     rounded-full
//                                     bg-[#f8fafc]
//                                     items-center
//                                     justify-center
//                                     text-[#08245c]
//                                     group-hover:bg-[#fff1f1]
//                                     group-hover:text-[#B5121B]
//                                     transition-all
//                                 "
//                 >
//                   <ArrowRight size={17} />
//                 </div>
//               </a>
//             ))}
//         </div>

//         {/* ================= VIEW ALL ================= */}

//         {!loading && currentData.length > 0 && (
//           <div
//             className="
//                         mt-10
//                         flex
//                         justify-center
//                     "
//           >
//             <a
//               href="#"
//               className="
//                                 group
//                                 inline-flex
//                                 items-center
//                                 gap-3
//                                 px-7
//                                 py-3.5
//                                 rounded-xl
//                                 bg-[#08245c]
//                                 text-white
//                                 text-sm
//                                 font-semibold
//                                 shadow-lg
//                                 hover:bg-[#B5121B]
//                                 transition-all
//                                 duration-300
//                             "
//             >
//               View All {currentTab.label}
//               <span
//                 className="
//                                 w-7
//                                 h-7
//                                 rounded-full
//                                 bg-white/10
//                                 flex
//                                 items-center
//                                 justify-center
//                                 group-hover:translate-x-1
//                                 transition-transform
//                             "
//               >
//                 <ArrowUpRight size={14} />
//               </span>
//             </a>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

/* STAT COMPONENT */

const Stat = ({ icon, value, label }) => {
  return (
    <div className="p-6 text-center border-b md:border-b-0 md:border-r last:border-0">
      <div className="flex justify-center text-[var(--terracotta)] mb-3">
        {icon}
      </div>

      <div className="text-2xl font-bold text-[var(--ink)]">{value}</div>

      <div className="text-sm text-gray-500 mt-1">{label}</div>
    </div>
  );
};

/* HIGHLIGHT COMPONENT */

const Highlight = ({ title, text }) => {
  return (
    <div className="p-7 rounded-2xl border border-[var(--cream-deep)] bg-[var(--paper)] hover:shadow-lg transition">
      <h3 className="text-xl font-bold text-[var(--ink)] mb-3">{title}</h3>

      <p className="text-gray-600 leading-7">{text}</p>
    </div>
  );
};

export default ExaminationCellPage;
